import React, { useMemo } from "react";
import {
    GiftingCartError,
    buildErrorPagePropsForErrorType,
    GIFTING_CART_ERROR_TYPE,
    useEffectOnce,
} from "@swiggy-private/core-ui";
import { closeWebview } from "@swiggy-private/checkout-core";

export const NetworkConnectivityError = ({ nrEventHandler }: { nrEventHandler?: (screenType: string) => void }) => {
    const props = useMemo(() => {
        const errorProps = buildErrorPagePropsForErrorType({
            primaryActionOnClick: () => {
                window.location.reload();
            },
            secondaryActionOnClick: () => {
                closeWebview();
            },
        });
        return errorProps[GIFTING_CART_ERROR_TYPE.NETWORK_ERROR];
    }, []);

    useEffectOnce(() => {
        nrEventHandler?.(GIFTING_CART_ERROR_TYPE.NETWORK_ERROR);
    });

    return <GiftingCartError {...props} />;
};
